import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';

import { AppContext } from '../../../providers/AppProvider';
import { ThemeContext } from '../../../providers/ThemeProvider';
import Logo from '../../../assets/imgs/logo.png';
import {
  NAV_ITEMS,
  MENU_ITEMS,
  MANAGER_MENU_ITEMS,
  MANAGER_NAV_ITEMS,
} from './constants';
import { makeSelectUser } from '../../../store/selectors';
import MobileMenu from './MobileMenu';
import { startImpersonate } from '../../../store/actions/auth';
import { MEMBERSHIP, isEnterprise } from '../../../config';
import { getFullPathToS3 } from '../../../utils/helper';
import { ROLE } from '../../../constants';
import {
  Container,
  Content,
  LogoWrapper,
  NavItemContainer,
  MenuContainer,
} from './Header.styled';
import { isMMI } from '../../../config';

const AUTH_PATHS = [
  '/sign-in',
  '/sign-up',
  '/forgot-password',
  '/reset-password',
];

const Header = ({ className }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(makeSelectUser());
  const { program, coreCurriculum } = useContext(AppContext);
  const { headerColor, logo } = useContext(ThemeContext);
  const [showMenu, setShowMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const isImpersonating = !!localStorage.getItem('admin_impersonate');

  useEffect(() => {
    if (!user && !AUTH_PATHS.some((path) => location.pathname.includes(path))) {
      // history.push('/sign-in');
    }
  }, [user]);

  useEffect(() => {
    setShowMenu(false);
    setShowMobileMenu(false);
  }, [location, location.pathname]);

  const handleToggleMenu = () => setShowMenu(!showMenu);
  const handleLogoClick = () => {
    history.push('/');
  };
  const handleImpersonate = () => {
    dispatch(startImpersonate());
  };

  const handleUnlock = () => {
    window.open(
      'https://www.adventuresincre.com/accelerator/endorsements/',
      '_blank'
    );
  };

  const renderItem = (item) => {
    if (item.type === 'divider') {
      return <div key={item.key} className="divider" />;
    }

    return (
      <div className="menu-item-wrapper">
        <div
          className="account-item w-full h-full"
          key={item.key}
          onClick={() =>
            item.external
              ? window.open(item.path, '_blank')
              : history.push(item.path)
          }
        >
          {item.label}
        </div>
      </div>
    );
  };

  return (
    <Container className={className} bg={headerColor}>
      <Content>
        {isEnterprise ? (
          <div className="flex items-center">
            <LogoWrapper className="cursor-pointer" onClick={handleLogoClick}>
              <img className={isMMI ? "mmi" : undefined} src={isMMI ? "/mmi-logo.png" : "/enterprise-logo.png"} alt="logo_img" />
            </LogoWrapper>
            {logo && (
              <LogoWrapper
                className="cursor-pointer ml-5"
                onClick={handleLogoClick}
              >
                <img src={getFullPathToS3(logo, 'logos')} alt="logo_img" />
              </LogoWrapper>
            )}
          </div>
        ) : (
          <LogoWrapper className="cursor-pointer" onClick={handleLogoClick}>
            <img src={Logo} alt="logo_img" />
          </LogoWrapper>
        )}
        {/* {expiresIn < 15 && (
          <div className="expire-notify text-white">
            Your program will be expired in <strong>{expiresIn}</strong> days.
          </div>
        )} */}
        {user && (
          <NavItemContainer>
            {user.membership === MEMBERSHIP.ACCELERATOR_CORE && (
              <div
                className="header-item text-white whitespace-nowrap"
                onClick={handleUnlock}
              >
                Upgrade
              </div>
            )}
            {user &&
              (user.role === ROLE.Manager ||
                user.role === ROLE.Admin_Non_Student
                ? MANAGER_NAV_ITEMS
                : NAV_ITEMS
              ).map((item) =>
                item.external ? (
                  <div
                    key={item.key}
                    className="header-item text-white whitespace-nowrap"
                    onClick={() => window.open(item.path, '_blank')}
                  >
                    {item.label}
                  </div>
                ) : item.key === 'core' &&
                  (!program || !coreCurriculum) ? null : (
                  <Link
                    key={item.key}
                    className="text-white whitespace-nowrap"
                    to={
                      item.path
                        ? item.path
                        : item.key === 'core' &&
                        program &&
                        coreCurriculum &&
                        `/programs/${program.id}/${coreCurriculum.id}/courses`
                    }
                  >
                    {item.label}
                  </Link>
                )
              )}
            {user &&
              (user.role?.toLowerCase() === ROLE.Manager ||
                user.role?.toLowerCase() === ROLE.Admin_Non_Student ||
                user.role?.toLowerCase() === ROLE.Admin ||
                user.role?.toLowerCase() === ROLE.Manager_Student) && (
                <Link className="text-white whitespace-nowrap" to="/manage">
                  Enterprise
                </Link>
              )}
            <div
              className="text-white ml-9 cursor-pointer hover:underline whitespace-no-wrap"
              onClick={handleToggleMenu}
            >
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.2546 15.5055C17.778 14.439 17.0863 13.4702 16.2182 12.6531C15.3526 11.8337 14.3274 11.1804 13.1989 10.7293C13.1888 10.7245 13.1787 10.7221 13.1686 10.7173C14.7427 9.64322 15.7659 7.89359 15.7659 5.9196C15.7659 2.6495 12.9614 0 9.5 0C6.03859 0 3.23408 2.6495 3.23408 5.9196C3.23408 7.89359 4.25735 9.64322 5.83141 10.7197C5.8213 10.7245 5.81119 10.7269 5.80109 10.7317C4.66918 11.1828 3.6535 11.8296 2.78183 12.6555C1.91448 13.4732 1.22294 14.4418 0.745404 15.5079C0.276274 16.5516 0.0232621 17.6706 6.31796e-05 18.8043C-0.000611177 18.8297 0.00411865 18.8551 0.0139741 18.8788C0.0238295 18.9025 0.0386111 18.9242 0.0574479 18.9424C0.0762846 18.9606 0.0987954 18.9751 0.123654 18.985C0.148512 18.9949 0.175215 19 0.202189 19H1.71814C1.82931 19 1.91774 18.9165 1.92026 18.8138C1.97079 16.9711 2.75403 15.2454 4.1386 13.9373C5.57117 12.5839 7.47368 11.8392 9.5 11.8392C11.5263 11.8392 13.4288 12.5839 14.8614 13.9373C16.246 15.2454 17.0292 16.9711 17.0797 18.8138C17.0823 18.9188 17.1707 19 17.2819 19H18.7978C18.8248 19 18.8515 18.9949 18.8763 18.985C18.9012 18.9751 18.9237 18.9606 18.9426 18.9424C18.9614 18.9242 18.9762 18.9025 18.986 18.8788C18.9959 18.8551 19.0006 18.8297 18.9999 18.8043C18.9747 17.6633 18.7245 16.5534 18.2546 15.5055ZM9.5 10.0251C8.3403 10.0251 7.24882 9.59786 6.42768 8.82211C5.60654 8.04636 5.15428 7.0152 5.15428 5.9196C5.15428 4.824 5.60654 3.79284 6.42768 3.01709C7.24882 2.24133 8.3403 1.81407 9.5 1.81407C10.6597 1.81407 11.7512 2.24133 12.5723 3.01709C13.3935 3.79284 13.8457 4.824 13.8457 5.9196C13.8457 7.0152 13.3935 8.04636 12.5723 8.82211C11.7512 9.59786 10.6597 10.0251 9.5 10.0251Z"
                  fill="#E8B12C"
                />
              </svg>
            </div>
            {showMenu && (
              <OutsideClickHandler onOutsideClick={() => setShowMenu(false)}>
                <MenuContainer>
                  {user &&
                    (user.role?.toLowerCase() === ROLE.Manager ||
                      user.role?.toLowerCase() === ROLE.Admin_Non_Student ||
                      user.role?.toLowerCase() === ROLE.Admin ||
                      user.role?.toLowerCase() === ROLE.Manager_Student
                      ? MANAGER_MENU_ITEMS.concat(MENU_ITEMS)
                      : MENU_ITEMS
                    ).map((item) => !item.hidden && renderItem(item))}
                  {user && user.role === 'admin' && !isImpersonating && (
                    <div className="menu-item-wrapper">
                      <div
                        className="account-item w-full h-full"
                        onClick={handleImpersonate}
                      >
                        Impersonate
                      </div>
                    </div>
                  )}
                </MenuContainer>
              </OutsideClickHandler>
            )}
          </NavItemContainer>
        )}
        {user && (
          <span
            className="hidden sm:block"
            role="button"
            key={showMenu ? 'show' : 'hide'}
            onClick={() => setShowMobileMenu(true)}
          >
            <svg
              width="27"
              height="15"
              viewBox="0 0 27 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.00916H25.5M9.5 7.2254H25.5M18.5 13.4416H25.5"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {showMobileMenu && (
              <OutsideClickHandler
                onOutsideClick={() => setShowMobileMenu(false)}
              >
                <MobileMenu user={user} />
              </OutsideClickHandler>
            )}
          </span>
        )}
      </Content>
    </Container>
  );
};

export default Header;
